import React, {useState} from 'react';
import {useForm} from 'react-hook-form';
import {useDispatch} from 'react-redux';
import {forgotPassword} from './slice/authSlice';
import ROUTES from '../../../routes';
import {Link} from 'react-router-dom';
import {toast} from 'react-toastify';
import useErrorProvider from '../../common/useErrorProvider';
import {useNavigate} from 'react-router';

export const ForgetPassword = () => {
  const {
    register,
    handleSubmit,
    formState: {errors}
  } = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const {apiErrorMsg, clearApiError, handleApiError} = useErrorProvider();

  const onSubmit = data => {
    setLoading(true);
    clearApiError();
    dispatch(forgotPassword(data)).then(action => {
      if (forgotPassword.fulfilled.match(action)) {
        toast.success(`Password reset request sent to the email address provided.
        Please check your email address for next steps.`);
        navigate(ROUTES.SIGN_IN, {replace: true});
      }
      else {
        handleApiError({action});
      }
    }).catch(error => {
      handleApiError({error, message: 'Error when sending a password reset email.'});
    }).finally(() => {
      setLoading(false);
    });
  };

  return (
    <div className='grid-x align-center'>
      <div className='small-10 medium-6 large-4 cell padding-bottom-2'>
        <section>
          <div className='padding-vertical-2'>
            <h1>Forgot Password</h1>
            <p>This is going to be a reset your forgotten password</p>
          </div>
          {loading && <div className='loader-wrapper'><div className='loader'/></div>}
          {!loading &&
            <div className='form-card-wrapper'>
              <form onSubmit={handleSubmit(onSubmit)}>
                {apiErrorMsg && <div className='alert callout'>{apiErrorMsg}</div>}
                <label>Email Address
                  <input
                    className='form-card'
                    type='email'
                    {...register('email', {required: true})}
                  />
                  {errors.email && <p className='error'>Email is required.</p>}
                </label>
                <button
                  className='button primary expanded'
                  type='submit'
                >Submit
                </button>
                <Link
                  className='button primary hollow expanded '
                  to={ROUTES.SIGN_IN}
                >Back</Link>
              </form>
            </div>
          }
        </section>
      </div>
    </div>
  );
};
